import { footerLinks } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-100/60 pt-14 md:pt-20 pb-8">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10 mb-12">
          <div>
            <h4 className="font-label text-sm font-semibold text-foreground-950 mb-4 uppercase tracking-wider">
              Redaktion
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.editorial.map((link) => (
                <li key={link.name}>
                  <a href={link.url} className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-label text-sm font-semibold text-foreground-950 mb-4 uppercase tracking-wider">
              SEO Hub
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.seo.map((link) => (
                <li key={link.name}>
                  <a href={link.url} className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-label text-sm font-semibold text-foreground-950 mb-4 uppercase tracking-wider">
              Kategorien
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.url}
                    target={link.external ? '_blank' : undefined}
                    rel={link.external ? 'noopener nofollow' : undefined}
                    className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-label text-sm font-semibold text-foreground-950 mb-4 uppercase tracking-wider">
              Rechtliches
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.legal.map((link) => (
                <li key={link.name}>
                  <a href={link.url} className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-secondary-200/70 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div>
            <span className="font-heading text-2xl font-bold text-foreground-950">OOPBUY</span>
            <span className="font-heading text-2xl font-bold text-foreground-950 ml-2">Spreadsheet</span>
            <p className="text-xs text-foreground-500 mt-1">
              Dein Tool für Taobao, Weidian & Yupoo in Deutschland
            </p>
          </div>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-500 whitespace-nowrap">
              &copy; 2025 oopbuyspread.rest
            </span>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-foreground-950 transition-colors cursor-pointer" aria-label="Twitter">
                <i className="ri-twitter-x-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-foreground-950 transition-colors cursor-pointer" aria-label="LinkedIn">
                <i className="ri-linkedin-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-foreground-950 transition-colors cursor-pointer" aria-label="Pinterest">
                <i className="ri-pinterest-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}